import { IconProps } from './type';

export const ICAdd: React.FC<IconProps> = ({
    stroke = 'white',
    fill = '#46485C',
    width = 24,
    height = 24,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.5 11V11.5H13H19C19.1326 11.5 19.2598 11.5527 19.3536 11.6464C19.4473 11.7402 19.5 11.8674 19.5 12C19.5 12.1326 19.4473 12.2598 19.3536 12.3536C19.2598 12.4473 19.1326 12.5 19 12.5H13H12.5V13V19C12.5 19.1326 12.4473 19.2598 12.3536 19.3536C12.2598 19.4473 12.1326 19.5 12 19.5C11.8674 19.5 11.7402 19.4473 11.6464 19.3536C11.5527 19.2598 11.5 19.1326 11.5 19V13V12.5H11H5C4.86739 12.5 4.74022 12.4473 4.64645 12.3536C4.55268 12.2598 4.5 12.1326 4.5 12C4.5 11.8674 4.55268 11.7402 4.64645 11.6464C4.74022 11.5527 4.86739 11.5 5 11.5H11H11.5V11V5C11.5 4.86739 11.5527 4.74022 11.6464 4.64645C11.7402 4.55268 11.8674 4.5 12 4.5C12.1326 4.5 12.2598 4.55268 12.3536 4.64645C12.4473 4.74022 12.5 4.86739 12.5 5V11Z"
                fill={fill}
                stroke={stroke}
            />
        </svg>
    );
};
